import React from "react";
import NewOrder from "./NewOrder";
import CardDiv from "modules/common/card-div/CardDiv";
import RepeatOrder from "./RepeatOrders";

function OpenOrders({subTab}) {
  return (
    <div className="d-flex gap-3 ">
      <div className="flex-1">
        <CardDiv component={<NewOrder subTab={subTab} />} title={"New order"} />
      </div>
      <div style={{flex:1.3}}>
        <CardDiv component={<RepeatOrder subTab={subTab} />} title={"Repeat order"} />
      </div>
    </div>
  );
}

export default OpenOrders;
